// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"04858ef0","830":"fef18a9e"}[chunkId] + ".chunk.js";
};